var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "260.8mm",
    height: "121.71mm",
    viewBox: "0 0 260.8 121.71",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3574"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m621.75 261.75h69.75v69.75h-69.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3584"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3620"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.1035e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3630"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.1035e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3640"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.1035e-5 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3650"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.1035e-5 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3664"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m525.92 232.31 71.71-6.38-6.38-71.72-71.71 6.39z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3674"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3690"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m491.37 231.56 39.66-15.18-15.18-39.66-39.66 15.18z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3700"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3726"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m612 153.75h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3736"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3746"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3756"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3766"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.2207e-4 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3776"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.2207e-4 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3786"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3798"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m373.5 114.75h84.75v84.75h-84.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3808"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3818"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4305e-5 0h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3842"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4551e-5 129.75h279.75v295.5h-279.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3852"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-351.52 -291.71)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 351.52 439.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 72.857h739.29v345h-739.29z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.13 168c0 27.96 22.49 50.62 50.25 50.62 27.75 0 50.25-22.66 50.25-50.62s-22.5-50.63-50.25-50.63c-27.76 0-50.25 22.67-50.25 50.63z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.13 168c0 27.96 22.49 50.62 50.25 50.62 27.75 0 50.25-22.66 50.25-50.62s-22.5-50.63-50.25-50.63c-27.76 0-50.25 22.67-50.25 50.63z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.88 94.875h17.25v45h-17.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.88 94.875h17.25v45h-17.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.63 94.875h17.25v45h-17.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.63 94.875h17.25v45h-17.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.63 180c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.63 180c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.38 184.5c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.38 184.5c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.9 176.34c0-1.08-0.87-1.95-1.95-1.95s-1.95 0.87-1.95 1.95 0.87 1.95 1.95 1.95 1.95-0.87 1.95-1.95z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3574)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.96875 -3.77e-7 -7.54e-7 .96875 621.75 261.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3584)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.384 30.601c3.206-1e-3 5.807 2.598 5.808 5.804s-2.597 5.807-5.804 5.808c-3.206 1e-3 -5.806-2.597-5.808-5.804v-2e-3c0-3.205 2.598-5.805 5.803-5.806h1e-3zm0 10.111c2.378 2e-3 4.307-1.925 4.308-4.303s-1.925-4.307-4.304-4.308c-2.378-2e-3 -4.306 1.925-4.308 4.303v3e-3c3e-3 2.376 1.928 4.302 4.304 4.305z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.984 25.997c-1.705 1.316-3.659 2.272-5.744 2.811-1.573 0.483-3.21 0.73-4.856 0.733-1.641-0.027-3.271-0.273-4.847-0.732-2.062-0.599-4.006-1.549-5.747-2.808-0.871-0.686-1.387-1.727-1.406-2.835v-5.55h24v5.55c-0.018 1.106-0.531 2.146-1.4 2.831zm-0.1-6.881h-21v4.05c0.014 0.642 0.313 1.244 0.816 1.644 1.591 1.14 3.362 2.004 5.24 2.556 1.445 0.421 2.939 0.648 4.444 0.675 1.503-5e-3 2.998-0.232 4.435-0.675 1.894-0.485 3.67-1.347 5.221-2.537 0.517-0.399 0.827-1.01 0.844-1.663z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 35.616h18v1.5h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 29.616h18v1.5h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 23.616h18v1.5h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 17.616h18v1.5h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.384 52.866h-21.75v6c0 1.657-1.343 3-3 3h-4.5c-1.657 0-3-1.343-3-3v-6h-21.75c-1.6569 0-3-1.343-3-3v-36c0-1.657 1.3431-3 3-3h54c1.657 0 3 1.343 3 3v36c0 1.657-1.343 3-3 3zm-30.75 6c0 0.828 0.672 1.5 1.5 1.5h4.5c0.828 0 1.5-0.672 1.5-1.5v-8.25c0-0.828-0.672-1.5-1.5-1.5h-4.5c-0.828 0-1.5 0.672-1.5 1.5zm32.25-45c0-0.828-0.672-1.5-1.5-1.5h-54c-0.8285 0-1.5 0.672-1.5 1.5v36c0 0.828 0.6715 1.5 1.5 1.5h21.75v-0.75c0-1.657 1.343-3 3-3h4.5c1.657 0 3 1.343 3 3v0.75h21.75c0.828 0 1.5-0.672 1.5-1.5z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m499.88 255.37c0 27.76 22.66 50.25 50.62 50.25s50.63-22.49 50.63-50.25c0-27.75-22.67-50.25-50.63-50.25s-50.62 22.5-50.62 50.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.88 255.37c0 27.76 22.66 50.25 50.62 50.25s50.63-22.49 50.63-50.25c0-27.75-22.67-50.25-50.63-50.25s-50.62 22.5-50.62 50.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m524.63 296.62 25.5 49.5 25.5-49.5z",
    fill: "#4472c4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m524.63 296.62 25.5 49.5 25.5-49.5z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m657.38 129.08v25.79",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 5.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.38 154.12 17.99 72h216.76l18-72z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.38 154.12 17.99 72h216.76l18-72z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m516.47 239.22-4.1-13.54c-2.27-7.47-7.79-12.41-12.33-11.04-4.55 1.38-6.39 8.56-4.13 16.03l4.1 13.54z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m516.47 239.22-4.1-13.54c-2.27-7.47-7.79-12.41-12.33-11.04-4.55 1.38-6.39 8.56-4.13 16.03l4.1 13.54z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m594.87 233.17-4.11-13.54c-2.26-7.47-7.78-12.41-12.33-11.04-4.54 1.38-6.39 8.56-4.12 16.03l4.1 13.54z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m594.87 233.17-4.11-13.54c-2.26-7.47-7.78-12.41-12.33-11.04-4.54 1.38-6.39 8.56-4.12 16.03l4.1 13.54z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m515.33 274.14c0-1.08-0.87-1.95-1.95-1.95-1.07 0-1.94 0.87-1.94 1.95 0 1.07 0.87 1.95 1.94 1.95 1.08 0 1.95-0.88 1.95-1.95z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m536.57 274.14c0-1.08-0.88-1.95-1.95-1.95-1.08 0-1.95 0.87-1.95 1.95 0 1.07 0.87 1.95 1.95 1.95 1.07 0 1.95-0.88 1.95-1.95z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3664)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.99607 .088612 -.088613 -.99607 597.63 225.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3674)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.384 46.866h11.25v1.5h-11.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 42.366h11.25v1.5h-11.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 37.866h7.5v1.5h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.634 54.366h-4.5v3.3c0 0.32-0.203 0.605-0.506 0.709-7.864 2.625-16.363 2.654-24.244 0.083-7.881 2.572-16.38 2.543-24.244-0.082-0.303-0.104-0.506-0.389-0.506-0.71v-3.3h-4.5c-0.4142 0-0.75-0.336-0.75-0.75v-36c0-0.414 0.3358-0.75 0.75-0.75h24.075c0.315-1.319 1.494-2.25 2.85-2.25h4.65c1.356 0 2.535 0.931 2.85 2.25h24.075c0.414 0 0.75 0.336 0.75 0.75v36c0 0.414-0.336 0.75-0.75 0.75zm-6 2.76v-34.425c-7.335 2.223-15.165 2.223-22.5 0v34.425c7.321 2.32 15.179 2.32 22.5 0zm-46.5 0c7.321 2.32 15.179 2.32 22.5 0v-34.425c-7.335 2.223-15.165 2.223-22.5 0zm51.75-38.76h-24c-0.414 0-0.75-0.336-0.75-0.75v-0.075c0-0.787-0.638-1.425-1.425-1.425h-4.65c-0.787 0-1.425 0.638-1.425 1.425v0.075c0 0.414-0.336 0.75-0.75 0.75h-24v34.5h3.75v-31.2c0-0.414 0.336-0.75 0.75-0.75 0.083 0 0.165 0.013 0.244 0.04 7.631 2.545 15.881 2.545 23.512 0 0.013-2e-3 0.025-4e-3 0.038-6e-3 0.055-0.016 0.112-0.025 0.17-0.028 0.012 0 0.024-6e-3 0.036-6e-3s0.019 4e-3 0.028 4e-3c0.057 2e-3 0.113 0.011 0.168 0.026 0.012 0 0.025 4e-3 0.038 8e-3h0.01c7.631 2.545 15.881 2.545 23.512 0 0.079-0.026 0.161-0.039 0.244-0.038 0.414 0 0.75 0.336 0.75 0.75v31.2h3.75z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3690)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.21081 .55085 -.55085 .21081 515.85 176.72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.509 60.259-5.275 5.294c-1.171 1.172-3.07 1.174-4.243 3e-3l-45.078-45.078-4.52-14.112 14.065 4.57 45.049 45.085c1.169 1.171 1.17 3.067 2e-3 4.238zm-14.821-2.124 7.408-7.408-1.602-1.603-7.409 7.409zm-31.082-45.899-8.343-2.7103-1.729 1.7293 2.682 8.376c1.519 1.194 4.182 0.669 6.122-1.27 1.94-1.94 2.465-4.607 1.268-6.125zm-0.208 7.185c-1.341 1.398-3.166 2.23-5.1 2.325l33.727 33.727 7.409-7.407-33.707-33.739c-0.099 1.933-0.932 3.755-2.329 5.094zm45.047 37.661-5.289-5.294-7.408 7.408 5.3 5.3c0.585 0.587 1.535 0.587 2.121 2e-3 1e-3 0 2e-3 -1e-3 2e-3 -2e-3l5.276-5.293c0.585-0.586 0.584-1.536-2e-3 -2.121z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m512.63 267.75c0 8.91 7.72 16.12 17.25 16.12 9.52 0 17.25-7.21 17.25-16.12s-7.73-16.13-17.25-16.13c-9.53 0-17.25 7.22-17.25 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512.63 267.75c0 8.91 7.72 16.12 17.25 16.12 9.52 0 17.25-7.21 17.25-16.12s-7.73-16.13-17.25-16.13c-9.53 0-17.25 7.22-17.25 16.13z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m541.88 267.75c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m541.88 267.75c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m532.26 262.26c0-1.08-0.88-1.95-1.95-1.95-1.08 0-1.95 0.87-1.95 1.95s0.87 1.95 1.95 1.95c1.07 0 1.95-0.87 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m558.59 261.49c0-1.07-0.87-1.95-1.95-1.95-1.07 0-1.95 0.88-1.95 1.95 0 1.08 0.88 1.95 1.95 1.95 1.08 0 1.95-0.87 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557.63 242.25c0-5.59-7.22-10.13-16.13-10.13s-16.12 4.54-16.12 10.13h5.06c0-2.8 4.95-5.06 11.06-5.06s11.06 2.26 11.06 5.06z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m557.63 242.25c0-5.59-7.22-10.13-16.13-10.13s-16.12 4.54-16.12 10.13h5.06c0-2.8 4.95-5.06 11.06-5.06s11.06 2.26 11.06 5.06z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3726)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(612,153.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m68.135 23.293-4.056 1.439v6.767l3.261 1.379c0.381 0.162 0.56 0.601 0.399 0.983-0.1 0.237-0.315 0.407-0.569 0.448l-5.353 0.885v6.632l6.348 2.565c0.384 0.155 0.57 0.592 0.415 0.976-0.081 0.2-0.243 0.355-0.445 0.426l-4.056 1.439v6.767l3.261 1.379c0.381 0.162 0.559 0.602 0.398 0.983-0.081 0.191-0.237 0.34-0.431 0.412l-25.17 9.293c-0.162 0.06-0.34 0.062-0.503 6e-3l-33.975-11.849c-0.0709-0.024-0.1377-0.059-0.198-0.103-0.0968-0.075-2.3745-1.808-2.3745-7.13-0.0092-1.213 0.1299-2.422 0.414-3.6-0.8843-0.75-2.664-2.775-2.664-6.9-0.0153-2.969 0.9352-5.862 2.7082-8.243-0.3194-1.226-0.4735-2.49-0.4582-3.757 0-5.279 2.3205-7.425 2.4195-7.513 0.0659-0.06 0.1421-0.107 0.225-0.14l24-9.4443c0.088-0.0342 0.181-0.0517 0.274-0.0517 0.097-2e-4 0.192 0.0184 0.282 0.0547l35.878 14.495c0.384 0.155 0.57 0.592 0.415 0.976-0.081 0.2-0.243 0.355-0.445 0.426zm-7.818 11.775-28.342-11.293-23.742 9.346v6.009l23.501-9.237c0.178-0.071 0.377-0.071 0.556 0l28.026 11.325zm-28.311-26.169-23.572 9.2743c-0.366 0.408-1.8457 2.306-1.8457 6.317-0.0215 1.252 0.1487 2.5 0.5047 3.701 0.0812 0.255 0.0203 0.534-0.1597 0.732-1.7037 2.153-2.6194 4.824-2.595 7.57 0 4.458 2.3047 5.902 2.4 5.958 0.3001 0.174 0.4419 0.531 0.3427 0.864-0.3393 1.195-0.5045 2.433-0.4905 3.675 0 3.987 1.3883 5.56 1.7018 5.865l33.577 11.711 23.123-8.538c0.01 0 0.01-0.011 0-0.014l-32.986-13.365-21.999 8.659c-0.3853 0.152-0.8206-0.038-0.9722-0.423-0.0344-0.088-0.0521-0.181-0.0521-0.275v-7.5c1e-4 -0.308 0.1884-0.584 0.4748-0.698l22.276-8.769c0.178-0.071 0.377-0.071 0.556 0l30.693 12.405 2.768-1c0.01-4e-3 0.01-0.01 0-0.014l-33.745-13.635-24.249 9.529c-0.3854 0.152-0.8208-0.038-0.9724-0.423-0.0344-0.088-0.0521-0.181-0.0521-0.275v-7.62c1e-4 -0.308 0.1884-0.584 0.4748-0.698l24.494-9.642c0.177-0.07 0.374-0.07 0.552 0l28.896 11.513 3.194-0.525c0.014 0 0.015-9e-3 0-0.014l-32.338-13.095-21.999 8.659c-0.3853 0.152-0.8206-0.038-0.9722-0.423-0.0344-0.088-0.0521-0.181-0.0521-0.275v-7.5c1e-4 -0.308 0.1884-0.584 0.4748-0.698l22.276-8.769c0.178-0.071 0.377-0.071 0.556 0l30.693 12.405 2.768-1c0.01 0 0.01-0.01 0-0.014zm30.573 38.603-30.573-12.353-21.525 8.475v5.887l21.253-8.368c0.178-0.071 0.377-0.071 0.556 0l30.289 12.241zm0-22.5-30.573-12.353-21.525 8.475v5.887l21.253-8.368c0.178-0.071 0.377-0.071 0.556 0l30.289 12.241z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m297.46 153-7.11-12.23c-3.93-6.75-10.44-10.29-14.55-7.9-4.1 2.39-4.24 9.8-0.32 16.55l7.12 12.22z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m297.46 153-7.11-12.23c-3.93-6.75-10.44-10.29-14.55-7.9-4.1 2.39-4.24 9.8-0.32 16.55l7.12 12.22z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m364.87 165.88 17.75-8.18c9.81-4.52 15.76-12.52 13.3-17.86s-12.41-6.01-22.21-1.49l-17.76 8.18z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m364.87 165.88 17.75-8.18c9.81-4.52 15.76-12.52 13.3-17.86s-12.41-6.01-22.21-1.49l-17.76 8.18z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m383.16 171.07c1.73-5.26-3.7-11.77-12.12-14.54s-16.65-0.75-18.38 4.5l4.76 1.57c0.86-2.63 6.26-3.21 12.05-1.31 5.8 1.91 9.79 5.58 8.93 8.21z",
    fill: "#ffffff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m320.79 176.06c0-1.08-0.87-1.95-1.95-1.95-1.07 0-1.95 0.87-1.95 1.95 0 1.07 0.88 1.95 1.95 1.95 1.08 0 1.95-0.88 1.95-1.95z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3798)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1771,-1.88e-7,-3.77e-7,1.1771,373.5,114.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.884 66.366v-60h45v43.81l-16.19 16.19zm29.263-2.573 13.164-13.164c3e-3 -3e-3 3e-3 -8e-3 0-0.011-2e-3 -1e-3 -4e-3 -2e-3 -6e-3 -2e-3h-13.171v13.171c0 5e-3 3e-3 8e-3 8e-3 8e-3 2e-3 0 3e-3 -1e-3 5e-3 -2e-3zm-27.763-55.927v57h26.25v-15.75h15.75v-41.25z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3818)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,395.13,153.68)",
    fill: "#000000",
    fontFamily: "TimesNewRomanPS",
    fontSize: "12.025px",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 8.9826746 14.971125 20.214025 26.2145 35.209202",
    y: 0
  }, "Resume"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3842)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.1146,-1.88e-7,-2.4e-8,4.1042,-16.5,129.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3852)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.888 6.366h27v54.75h-27zm1.5 53.25h24v-51.75h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.388 7.8667v57.75h-36.004v-57.75h-10.496v-1.5h11.996v57.75h33.004v-57.75h12v1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.018 35.487c-1.169 0.415-2.453-0.196-2.869-1.364-1e-3 -3e-3 -1e-3 -5e-3 -2e-3 -7e-3h-4.263v-1.5h4.263c0.414-1.172 1.699-1.786 2.871-1.372s1.786 1.699 1.372 2.871c-0.227 0.641-0.731 1.145-1.372 1.372zm-0.746-2.871c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75c0.415 0 0.75-0.336 0.75-0.75s-0.335-0.75-0.75-0.75z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m369.89 185.92c0-1.07-0.87-1.95-1.95-1.95s-1.95 0.88-1.95 1.95c0 1.08 0.87 1.95 1.95 1.95s1.95-0.87 1.95-1.95z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.13 177.5c0-1.07-0.87-1.95-1.95-1.95-1.07 0-1.95 0.88-1.95 1.95 0 1.08 0.88 1.95 1.95 1.95 1.08 0 1.95-0.87 1.95-1.95z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.38 129.83v25.79",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 5.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg06);
export default __webpack_public_path__ + "static/media/06.2c3885d9cc28e5dbb132153357fea019.svg";
export { ForwardRef as ReactComponent };